import React from "react"
import { graphql } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { DateTime } from "luxon"

//import rehypeReact from "rehype-react"

import Layout from "components/Layout"
import Head from "components/Head"
import ShareBtns from "components/ShareBtns"
import CardRelation from "components/CardRelation"
import CardTip from "components/CardTip"

//const pkg = require("root/package.json")
const pjt = require("root/project.json")

//const renderAst = new rehypeReact({
//  createElement: React.createElement,
//  components: {
//    img: ZoomImage
//  }
//}).Compiler

export default ({ data }) => (
  <Layout>
    <Head
      id="news"
      pageTitle={data.airtable.data.title}
      pageDescription={data.airtable.data.content.childMarkdownRemark.excerpt}
      pageUrl={pjt.site.url + "/news/" + data.airtable.data.slug + "/"}
      pageOgImage={
        data.airtable.data.images
          ? data.airtable.data.images.localFileUrls[0]
          : null
      }
    />
    <section className="section is-item is-space-half">
      <article className="card is-separate">
        <header className="card-header">
          <div className="inner is-space-half">
            <h1 className="text is-dark-2 is-lg">{data.airtable.data.title}</h1>
            <p className="text is-font-en-modern is-dark-3 is-space-right-half is-sm">
              <span className="text is-inline-block">
                <FontAwesomeIcon
                  className="icon"
                  icon={["far", "calendar-alt"]}
                />
                <span className="text">公開日: </span>
                <span className="text">
                  {DateTime.fromISO(data.airtable.data.publishedAt, {
                    zone: "Asia/Tokyo"
                  }).toFormat("yyyy/MM/dd")}
                </span>
              </span>
            </p>
          </div>
        </header>
        <section className="card-content">
          <div className="inner is-padding-lg is-tablet-padding-xxl is-space-2x">
            <div
              className="wysiwyg is-max-width-560px is-centering is-external-link-area is-disabled-link-gyazo is-space is-sm"
              dangerouslySetInnerHTML={{
                __html: data.airtable.data.content.childMarkdownRemark.html
              }}
            />
            {data.airtable.data.items ? (
              <div className="box is-max-width-560px is-centering is-space">
                <ul className="grid is-gap-2x">
                  {data.airtable.data.items.map((edge, i) =>
                    edge.data.published === true ? (
                      <li className="col is-mobile-12" key={i}>
                        <CardRelation
                          to={`/items/${edge.data.slug}/`}
                          src={edge.data.images.localFileUrls[0]}
                          title={edge.data.title}
                        />
                      </li>
                    ) : null
                  )}
                </ul>
              </div>
            ) : null}
            {data.airtable.data.tips ? (
              <div className="box is-max-width-560px is-centering is-space">
                <ul className="grid is-gap-2x">
                  {data.airtable.data.tips.map((edge, i) =>
                    edge.data.published === true ? (
                      <li className="col is-mobile-12" key={i}>
                        <CardTip
                          to={`/tips/${edge.data.slug}/`}
                          src={edge.data.images.localFileUrls[0]}
                          title={edge.data.title}
                          publishedAt={edge.data.publishedAt}
                        />
                      </li>
                    ) : null
                  )}
                </ul>
              </div>
            ) : null}
            {data.airtable.data.columns ? (
              <div className="box is-max-width-560px is-centering is-space">
                <ul className="grid is-gap-2x">
                  {data.airtable.data.columns.map((edge, i) =>
                    edge.data.published === true ? (
                      <li className="col is-mobile-12" key={i}>
                        <CardTip
                          to={`/columns/${edge.data.slug}/`}
                          src={
                            edge.data.images
                              ? edge.data.images.localFileUrls[0]
                              : null
                          }
                          title={edge.data.title}
                          publishedAt={edge.data.publishedAt}
                        />
                      </li>
                    ) : null
                  )}
                </ul>
              </div>
            ) : null}
            <div className="box is-max-width-560px is-centering is-space">
              <h2 className="heading is-strong">
                <span className="icon">
                  <FontAwesomeIcon icon={["fas", "share-alt"]} />
                </span>
                <span className="text">シェア</span>
              </h2>
              <ShareBtns
                pageTitle={data.airtable.data.title}
                pageUrl={
                  pjt.site.url + "/items/" + data.airtable.data.slug + "/"
                }
              />
            </div>
          </div>
        </section>
      </article>
    </section>
  </Layout>
)

export const query = graphql`
  query GetNews($slug: String!) {
    airtable(table: { eq: "news" }, data: { slug: { eq: $slug } }) {
      data {
        title
        slug
        publishedAt
        images {
          localFileUrls
        }
        content {
          childMarkdownRemark {
            html
            excerpt(truncate: true)
          }
        }
        items {
          data {
            title
            published
            slug
            images {
              localFileUrls
            }
          }
        }
        tips {
          data {
            title
            published
            slug
            publishedAt
            images {
              localFileUrls
            }
          }
        }
        columns {
          data {
            title
            published
            slug
            publishedAt
            images {
              localFileUrls
            }
          }
        }
      }
    }
  }
`
